export const SET_TENANT = 'SET_TENANT';
export const SET_TENANT_BRANDING = 'SET_TENANT_BRANDING';
export const SET_TENANT_BRANDING_LOGO = 'SET_TENANT_BRANDING_LOGO';

export const POST_TENANT_BRANDING_REQUEST = 'POST_TENANT_BRANDING_REQUEST';
export const POST_TENANT_BRANDING_SUCCESS = 'POST_TENANT_BRANDING_SUCCESS';
export const POST_TENANT_BRANDING_ERROR = 'POST_TENANT_BRANDING_ERROR';